import { components } from "../generated/API";

export type GetCourse = components["schemas"]["GetCourse"];
export type CourseBase = components["schemas"]["CourseBase"];
export type GetBatch = components["schemas"]["GetBatch"];
export type GetUnappliedBatch = components["schemas"]["GetUnappliedBatch"];
export type CourseType = components["schemas"]["CourseType"];
export type ProfessionalStatus = components["schemas"]["ProfessionalStatus"];
export type UGDEGREE = components["schemas"]["UGDEGREE"];
export type PGDEGREE = components["schemas"]["PGDEGREE"];
export type GetApplicationType = components["schemas"]["GetApplication"];
export type GetProfileType = components["schemas"]["GetProfile"];
export type ApplicationStatus = components["schemas"]["ApplicationStatus"];
export type PatchProfileType = components["schemas"]["PatchProfile"];
export type GetOnboardingProgress = components["schemas"]["GetOnboardingProgress"];
export type SendAadharOTPResponse = components["schemas"]["SendAadharOTPResponse"];
export type AadhaarInfoType = components["schemas"]["AadhaarInfo"];
export type ProfileProgramType = components["schemas"]["ProgramInfo"];

export type ReferralsInputType = components["schemas"]["ReferralsInput"];

export type GetReferralsType = components["schemas"]["GetReferrals"];
export type ReferredProfileType = components["schemas"]["ReferredProfile"];

export type ReferralProgramInformationType = components["schemas"]["ReferralProgramInformation"];

export type GenderType = components["schemas"]["Gender"];
export type GetEventType = components["schemas"]["GetEvent"];
export type GetEventProfile = components["schemas"]["GetEventProfile"];
export type GetContestType = components["schemas"]["GetContest"];
export type GetContestURLType = components["schemas"]["GetContestURL"];
export type LeaderboardType = components["schemas"]["Leaderboard"];
export type LeaderboardDataType = components["schemas"]["LeaderboardData"];

export type GetCouponType = components["schemas"]["GetCoupon"];
export type GetCollegeType = components["schemas"]["GetCollege"];
export type GetSelfLearningCourseType = components["schemas"]["GetSelfLearningCourse"];
export type GetCourseEnrollmentType = components["schemas"]["GetCourseEnrollment"];
export type SelfLearningCourseStatusType = components["schemas"]["SelfLearningCourseStatus"];
export type ErrorResponseModelType = components["schemas"]["ErrorResponseModel"];
export type GetMSATAssessmentInfoType = components["schemas"]["GetAssessmentURLInfo"];
export type PaymentInfoOfRazorpayType = components["schemas"]["PaymentInfoOfRazorpay"];
export type EventsForTracking = components["schemas"]["EventsForTracking"];

export type MarkingSchemeType = components["schemas"]["MarkingScheme"];
export type CAPOneTimeLink = components["schemas"]["GetCapDemoSession"];


export type IsEntityRatedResponse = components["schemas"]["IsEntityRatedResponse"];
export const genderTypeMap = new Map<string | number, GenderType>();

genderTypeMap.set("MALE", "MALE");
genderTypeMap.set("FEMALE", "FEMALE");
genderTypeMap.set("OTHERS", "OTHERS");

export enum ApplicationStatusEnums {
  PROFILE_UNFILLED = "PROFILE_UNFILLED",
  INELIGIBLE = "INELIGIBLE",
  METTL_TO_BE_TAKEN = "METTL_TO_BE_TAKEN",
  METTL_STARTED = "METTL_STARTED",
  METTL_DESCISION_PENDING = "METTL_DESCISION_PENDING",
  METTL_FAILED = "METTL_FAILED",
  METTL_PASSED = "METTL_PASSED",
  INTERVIEW_BOOKING_PENDING = "INTERVIEW_BOOKING_PENDING",
  INTERVIEW_BOOKED = "INTERVIEW_BOOKED",
  INTERVIEW_DECISION_PENDING = "INTERVIEW_DECISION_PENDING",
  INTERVIEW_FAILED = "INTERVIEW_FAILED",
  DOCUMENTATION_PENDING = "DOCUMENTATION_PENDING",
  DOCUMENTATION_DECISION_PENDING = "DOCUMENTATION_DECISION_PENDING",
  DOCUMENTATION_FAILED = "DOCUMENTATION_FAILED",
  FELLOW = "FELLOW",
  FDN_FELLOW = "FDN_FELLOW",
  BATCH_CHANGE = "BATCH_CHANGE",
  DROP_OUT = "DROP_OUT",
  ASYNC = "ASYNC",
  ISA_SUCCESSFUL = "ISA_SUCCESSFUL",
  DISCONTINUED = "DISCONTINUED",
}

const t = {
  event_image_url: "https://dashboard.masaischool.com/static/media/event.0a928c16.png",
  instructor_name: "Prabhanjan",
  linkedin_url: "linkedin.com",
  twiiter_url: "twitter.co",
  instructor_image_url:
    "https://dashboard.masaischool.com/static/media/InstructorImage.0f048b44.svg",
  instructor_title: "Fullstack Developer",
  instructor_company: "Masai School",
  topics:
    "✅ Breakdown of MERN Stack,✅ How to learn MERN Stack?,✅ MEAN Stack VS MERN Stack,✅ Best MERN stack projects to build",
  details_title: "Crack the Code",
  details_subtitle:
    "Education is the passport to the future, for tomorrow belongs to those who prepare for it today. We invite you to an exclusive session on the ‘How to become a MERN Stack Developer?’ by Prabhanjan Padhye, Senior Software Engineer, Masai School. He comes with experience of 4+ years in the industry. This session will be empowering you with in-depth knowledge of MERN Stack.",
};

export type SectionScores = {
  sectionMaxScore?: number | 0;
  sectionName?: string | null;
  sectionScore?: number | 0;
  category?: QuestionCategory;
}[];

export enum QuestionCategory {
  cognitive_ability_sectionA = "Cognitive Ability - Section A",
  cognitive_ability_sectionB = "Cognitive Ability - Section B",
  cognitive_ability_sectionC = "Cognitive Ability - Section C",
  cognitive_ability_sectionD = "Cognitive Ability - Section D",
  attention_to_details = "Attention to Details",
  communication_score = "communication_score",
  interview = "Interview",
}

export enum ReferralStatus {
  Signed_Up = "Signed Up",
  Application_Registered = "Application Registered",
  MSAT_Pending = "MSAT Pending",
  MSAT_Started = "MSAT Started",
  MSAT_Cleared = "MSAT Cleared",
  MSAT_Not_Cleared = "MSAT Not Cleared",
  Admitted = "Admitted",
  Batch_Change = "Batch Change",
  Drop_Out = "Drop Out",
  Fellow = "Fellow",
  Async = "Async",
  ISA_Successful = "PAP Successful",
  Application_Closed = "Application Closed",
  Discontinued = "Discontinued",
  Payment_Pending = "Payment Pending",
  Payment_Successful = "Payment Successful",
  Scholarship_Test_To_be_Taken = "Scholarship Test To be Taken",
  Scholarship_Test_Failed = "Scholarship Test Failed",
  Scholarship_Test_Passed = "Scholarship Test Passed",
  Coding_test_to_be_taken = "Coding test to be taken",
  Coding_Test_Passed = "Coding Test Passed",
  Coding_Test_Failed = "Coding Test Failed",
}
